import { type ExpressionType } from '../../IExpression.ts';
import { type IConditionExpression } from '../condition/IConditionExpression.ts';
import { type IFunctionExpression } from '../function/IFunctionExpression.ts';

export interface IConditionGroupExpression {
  /** conditionGroup */
  type: ExpressionType.ConditionGroup;
  /** Operatore su un insieme di espressioni booleane di confronto (condizioni) */
  operator: ConditionGroupOperator;
  conditions: IConditionItem[];
}

export type IConditionItem =
  | IConditionExpression
  | IConditionGroupExpression
  | IFunctionExpression;

// TODO: Supportare anche il not
export enum ConditionGroupOperator {
  And = 'and',
  Or = 'or',
}
